import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useFragment, graphql } from 'react-relay';
import { trackUserInteractionOnce } from '../helpers/checkoutTracking';
import { FormattedMessage } from 'dibs-react-intl';
import { Radio } from 'dibs-elements/exports/Radio';
import { PANES, STATES, ACTIONS } from '../constants/checkoutConstants';
import styles from './styles/CheckoutShippingAddressList.scss';

// components
import { CheckoutActions } from '../shared/CheckoutActions';
import CheckoutShippingForm from './CheckoutShippingForm';

const CheckoutAddShippingAddress = props => {
    const {
        viewer: viewerRef,
        buyer: buyerRef,
        actions,
        isSelected = false,
        isComputing,
        onSelect,
        onChange,
        onBlur,
        onSubmit,
    } = props;

    const viewer = useFragment(
        graphql`
            fragment CheckoutAddShippingAddress_viewer on Viewer {
                ...CheckoutShippingForm_viewer
            }
        `,
        viewerRef
    );
    const buyer = useFragment(
        graphql`
            fragment CheckoutAddShippingAddress_buyer on User {
                ...CheckoutShippingForm_buyer
            }
        `,
        buyerRef
    );

    const label = (
        <div className={styles.label}>
            <FormattedMessage
                id="checkout.CheckoutAddShippingAddress.label"
                defaultMessage="Add new address"
            />
            <CheckoutActions
                type={PANES.PANE_SHIPPING}
                serviceId={STATES.STATE_NEW}
                actions={isSelected ? { [ACTIONS.ACTION_CANCEL]: actions.onCancel } : {}}
            />
        </div>
    );

    return (
        <div
            className={classnames(styles.radioContainer, {
                [styles.clickable]: !isSelected,
            })}
            data-tn="checkout-row-container"
        >
            <Radio
                label={label}
                name={PANES.PANE_SHIPPING}
                value={STATES.STATE_NEW}
                checked={isSelected}
                disabled={isComputing}
                dataTn={[PANES.PANE_SHIPPING, STATES.STATE_NEW, 'wrapper'].join('-')}
                onChange={(value, event) => {
                    trackUserInteractionOnce();
                    if (isSelected) {
                        return null;
                    }
                    return onSelect(event, value, isSelected);
                }}
            />
            {isSelected && (
                <CheckoutShippingForm
                    {...{ viewer, buyer, isComputing, onBlur, onChange, onSubmit }}
                />
            )}
        </div>
    );
};

CheckoutAddShippingAddress.propTypes = {
    viewer: PropTypes.object.isRequired,
    buyer: PropTypes.object,
    actions: PropTypes.object.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isComputing: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default CheckoutAddShippingAddress;
